import { ArrowLeft } from 'lucide-react'

/**
 * PlatformBanner — the coloured header of a product's pages in ProTrack (its rooms, one room).
 * The dashboard has a fuller one of its own; this is the same family, smaller, so moving from the
 * dashboard into a room does not feel like leaving the product. The colours come from the theme
 * variables set by the page around it.
 *
 *   back   {label, onClick}   the way out, shown top-left in the banner
 *   kicker small line above the title (the product's name)
 *   title  the page's heading
 *   children  the line under the heading
 */
export default function PlatformBanner({ theme, back, kicker, title, children }) {
  return (
    <div className="relative overflow-hidden rounded-3xl text-white shadow-lg px-5 py-4 sm:px-7 sm:py-5 mb-5" style={{ background: theme.hero }}>
      <span className="pointer-events-none absolute -right-10 -top-16 w-52 h-52 rounded-full bg-white/10" aria-hidden="true" />
      <span className="pointer-events-none absolute right-28 -bottom-24 w-48 h-48 rounded-full bg-white/[0.07]" aria-hidden="true" />
      <div className="relative">
        {back && (
          <button type="button" onClick={back.onClick} className="text-xs font-medium text-white/80 hover:text-white inline-flex items-center gap-1 mb-2">
            <ArrowLeft className="w-3.5 h-3.5" /> {back.label}
          </button>
        )}
        {kicker && <p className="text-[11px] font-semibold uppercase tracking-wider text-white/75">{kicker}</p>}
        <h1 className="text-2xl sm:text-3xl font-bold leading-tight tracking-tight">{title}</h1>
        {children && <div className="text-sm text-white/85 mt-1">{children}</div>}
      </div>
    </div>
  )
}
